import {Icon} from "ant-design-vue";

export const admin_icon = Icon.createFromIconfontCN({
    scriptUrl:'//at.alicdn.com/t/c/font_3421580_5jw4xzzlmjj.js',
})
